// extracted by mini-css-extract-plugin
export default {"box":"JvjTebG7mLKfr_VLMZVD"};